// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__5Y-ug","loader":"Loader_loader__E3SNJ","spin":"Loader_spin__MwlqE"};